import { Component, Input, OnInit, ElementRef, Output, EventEmitter } from '@angular/core';

@Component({
	selector: '[appDataTable]',
	template: '<div class="table-responsive">' +
		'<table class="table">' +
		'<tr>' +
		'<th style = "text-transform:uppercase;" *ngFor = "let value of header">{{value.key}}</th>' +
		'<th>' +
		'ACTIONS' +
		'</th>' +
		'</tr>' +
		'<tr *ngFor = "let object of dataSet">' +
		'<td *ngFor = "let value of header" style = "padding:5px;">' +
		'	{{object[value.key]}} ' +
		'</td>' +
		'<td *ngIf = "showAction" class="td-actions text-left" style = "display: flex;flex-direction: row;">' +
		'<button  style = "flex:1 0 auto;margin:3px;" mat-raised-button type="button" class="btn btn-success" (click) = "editObject(object);">' +
		'<i class="material-icons">edit</i>' +
		'</button>' +
		'<button style = "flex:1 0 auto;margin:3px;" mat-raised-button type="button" class="btn btn-danger" (click) = "deleteObject(object)">' +
		'<i class="material-icons">delete</i>' +
		'</button>' +
		'</td>' +
		'</tr>' +

		'</table>' +
		'</div>'
})


export class DataTableDirective implements OnInit {

	public el: HTMLElement;
	public showAction: boolean = false;
	@Input('dataSet') dataSet: Array<any>;

	@Output() deleteEvent = new EventEmitter<any>();
	@Output() editEvent = new EventEmitter<any>();

	public header: Array<any> = [];

	public valuesToNotShow: Array<string> = [
		"id",
		"token",
		"password",
		"last_login",
		"facebook_connected",
		"profile_pic",
		"dob",
		"address",
		"updated_at",
		"role"
	];


	constructor(el: ElementRef) {
		this.el = el.nativeElement;
	}

	ngOnInit() {
		setTimeout(() => {
			console.log(this.dataSet);
			var tempObject = this.dataSet[0]
			for (var key in tempObject) {
				if (this.valuesToNotShow.indexOf(key) == -1) {
					this.header.push({ key: key });
				}
			}

			console.log(this.header);
		});

		setTimeout(() => {
			this.showAction = true;
		}, 1000)
	}

	editObject(object) {
		this.editEvent.emit(object);
	}

	deleteObject(object) {
		this.deleteEvent.emit(object);
	}

}



// WEBPACK FOOTER //
// ./src/app/directives/data-table.directive.ts